import SEO from "../../components/SEO";
import {
  BsBoxSeam,
  BsSearch,
  BsCreditCard,
  BsTruck,
  BsCheckCircle,
} from "react-icons/bs";

export const HowItWorksPage = () => {
  const steps = [
    {
      icon: <BsSearch className="text-5xl text-purple-600" />,
      title: "1. Enter Your Details",
      description:
        "Select your pickup and delivery locations, choose your parcel size, and pick your preferred delivery speed.",
    },
    {
      icon: <BsCreditCard className="text-5xl text-purple-600" />,
      title: "2. Get Instant Quote",
      description:
        "See transparent pricing upfront. Choose from same-day or next-day delivery options that fit your budget.",
    },
    {
      icon: <BsBoxSeam className="text-5xl text-purple-600" />,
      title: "3. Book & Pay",
      description:
        "Confirm your booking and pay securely via EFT or mobile payment. You'll receive a confirmation and tracking number.",
    },
    {
      icon: <BsTruck className="text-5xl text-purple-600" />,
      title: "4. Driver Pickup",
      description:
        "A verified driver already traveling your route will collect your parcel at the scheduled time.",
    },
    {
      icon: <BsCheckCircle className="text-5xl text-purple-600" />,
      title: "5. Track & Receive",
      description:
        "Track your parcel in real-time and receive notifications. Your parcel arrives safely at its destination.",
    },
  ];

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-cyan-100 to-fuchsia-200"><SEO title="How It Works" description="Send parcels in 5 easy steps with Parcelin. Enter details, get a quote, book, track, and receive. Simple, affordable delivery across South Africa." path="/how-it-works" />
      {/* Hero Section */}
      <div className="text-center py-16 px-5">
        <h1 className="text-4xl md:text-5xl font-bold text-purple-800 mb-4">
          How Parcelin Works
        </h1>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto">
          Parcel Delivery, Done Right. Simple, affordable, and eco-friendly
          parcel delivery in 5 easy steps.
        </p>
      </div>

      {/* Steps Section */}
      <div className="max-w-6xl mx-auto px-5 pb-16">
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 md:p-10 hover:shadow-xl transition-shadow"
            >
              <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                <div className="flex-shrink-0">{step.icon}</div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-lg text-gray-700">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Parcelin Section */}
      <div className="bg-white py-16 px-5">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-purple-800 text-center mb-12">
            Why Choose Parcelin?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="text-4xl mb-4">💰</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Affordable Pricing
              </h3>
              <p className="text-gray-700">
                Save money with our competitive rates. No hidden fees, just
                transparent pricing.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="text-4xl mb-4">🌍</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Eco-Friendly
              </h3>
              <p className="text-gray-700">
                We use vehicles already on the road, reducing emissions and
                helping the environment.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="text-4xl mb-4">⚡</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Fast & Reliable
              </h3>
              <p className="text-gray-700">
                Same-day and next-day delivery options with real-time tracking
                for peace of mind.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Secure & Insured
              </h3>
              <p className="text-gray-700">
                All parcels are insured and handled by verified drivers for your
                security.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="text-4xl mb-4">📱</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Easy to Use
              </h3>
              <p className="text-gray-700">
                Simple booking process with instant quotes and real-time
                tracking.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="text-4xl mb-4">🤝</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                Trusted Service
              </h3>
              <p className="text-gray-700">
                Join thousands of satisfied customers across Limpopo and
                Gauteng.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 px-5">
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-br from-purple-600 to-fuchsia-600 rounded-xl p-12 text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Send Your Parcel?
          </h2>
          <p className="text-xl mb-8">
            Get started in minutes with Parcelin's simple booking process.
          </p>
          <a
            href="/"
            className="inline-block bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors text-lg"
          >
            Start Sending Now
          </a>
        </div>
      </div>
    </div>
  );
};
